import currency from "currency.js";

/**
 * Get BNPL fee percentage from environment variable
 * @returns The BNPL fee percentage (default: 15)
 */
function getBnplFeePercentage(): number {
  const envFee = import.meta.env.VITE_BNPL_FEE_PERCENTAGE;
  if (envFee) {
    const parsedFee = parseFloat(envFee);
    if (!isNaN(parsedFee) && parsedFee >= 0) {
      return parsedFee;
    }
  }
  return 15; // Default fallback
}

/**
 * Calculate BNPL fee for a given price
 * @param originalPrice - The original price without fee
 * @returns totalPrice with BNPL fee included
 */
export function includeBnplFee(originalPrice: number): number {
  const actualFeePercentage = getBnplFeePercentage();
  const originalPriceCurrency = currency(originalPrice, { precision: 3 });
  const feeAmount = originalPriceCurrency
    .multiply(actualFeePercentage)
    .divide(100);
  const totalPrice = originalPriceCurrency.add(feeAmount);

  return totalPrice.value;
}

/**
 * Calculate monthly installment amount for BNPL
 * @param totalPrice - The total price including BNPL fee
 * @param installments - Number of installments
 * @returns Monthly installment amount
 */
export function calculateMonthlyInstallment(
  totalPrice: number,
  installments: number,
): number {
  const totalPriceCurrency = currency(totalPrice, { precision: 3 });
  const monthlyPayment = totalPriceCurrency.divide(installments);

  return monthlyPayment.value;
}
